/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateWhatsAppFirstContactAutomationDataSchema = z.object({
	enabled: z.boolean(),
	templateId: z.string().uuid().nullable().optional(),
	scoreThreshold: z.number().nullable().optional(),
})

export type UpdateWhatsAppFirstContactAutomationDataSchema = z.infer<
	typeof updateWhatsAppFirstContactAutomationDataSchema
>
